import { createContext, useState, useEffect } from "react";
import apiService from "./api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const verificaAuth = async () => {
      try {
        const session = await apiService.checkSession();
        setIsAuthenticated(session.success);
        setIsAdmin(session.is_admin || false);
      } catch (error) {
        console.error("Errore nel controllo della sessione", error);
        setIsAuthenticated(false);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };
    verificaAuth();
  }, []);

 
  const login = async (username, password) => {
      await apiService.login({ username, password });
      try {
        const session = await apiService.checkSession();
        setIsAuthenticated(session.success);
        setIsAdmin(session.is_admin || false);
        return session;
      } catch {
        setIsAuthenticated(false);
        setIsAdmin(false);
        return { success: false, is_admin: false };
      }
    };


  const logout = async () => {
    try {
      await apiService.logout();
    } catch (err) {
      console.error("Logout fallito", err); 
    } finally {
      setIsAuthenticated(false);
      setIsAdmin(false); 
    }
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, isAdmin, loading, login, logout}}>
      {children}
    </AuthContext.Provider>
  );
};
